export default __webpack_public_path__ + "static/media/icon-news-portal-round.71d2351a.svg";